<div class="flex flex-col gap-3">
  @for (item of items(); track item.id) {
    <div class="p-2 flex gap-4 items-center rounded-lg cursor-pointer referral" (click)="onReferralClick(item)">
      @if (selectionEnabled()) {
        <label
          nz-checkbox
          [nzChecked]="selectedReferralIds().has(item.id)"
          (click)="$event.stopPropagation()"
          (nzCheckedChange)="onItemCheck(item.id, $event)"
        ></label>
      }
      <div class="size-[3.5rem]">
        <app-user-avatar-v2 [user]="referralAsUser(item)" />
      </div>
      <div class="flex-1">
        <span class="text-[#2C3035] text-[1.125rem] font-medium">{{ item.full_name }}</span>
      </div>
      <div class="text-[#505760] text-[1.125rem]">
        {{ 'referral.referredOn' | translate }}
        {{ getLastContactedDate(item.timestamp) }}
      </div>
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M5.64644 13.1868C5.45118 12.9915 5.45118 12.675 5.64644 12.4797L10.1262 7.99992L5.64644 3.52012C5.45118 3.32485 5.45118 3.00832 5.64644 2.81305C5.8417 2.61779 6.15829 2.61779 6.35355 2.81305L11.1869 7.64639C11.3821 7.84165 11.3821 8.15819 11.1869 8.35345L6.35355 13.1868C6.15829 13.3821 5.84171 13.3821 5.64644 13.1868Z"
            fill="#505760"
          />
        </svg>
      </i>
    </div>
  }
</div>
